import { Component, HostListener, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { LecturaService } from 'src/app/services/lectura.service';

@Component({
  selector: 'app-codigo-qr-publico',
  templateUrl: './codigo-qr-publico.component.html',
  styleUrls: ['./codigo-qr-publico.component.scss'],
})
export class CodigoQrPublicoComponent implements OnInit {
  public id = '';
  innerWidth = 500;
  public data: any[];
  constructor(
    private route: ActivatedRoute,
    private lecturaSvc: LecturaService
  ) {
    this.id = this.route.snapshot.paramMap.get('id') || '';
  }

  ngOnInit(): void {
    this.innerWidth = window.innerWidth * 0.9;

    this.lecturaSvc
      .consultaHorariosYFechaFinServicio(this.id)
      .subscribe((result) => {
        this.data = result;
      });
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.innerWidth = window.innerWidth * 0.9;
    console.log(this.innerWidth);
  }

  descargarImagen(evento: any) {
  //  console.log(evento.srcElement.currentSrc);
    let datablob = this.convertToBlob(evento.srcElement.currentSrc);

    let url = window.URL.createObjectURL(datablob);
    let a = document.createElement('a');
    document.body.appendChild(a);
    a.setAttribute('style', 'display: none');
    a.href = url;
    a.download = 'codigoQR.png';
    a.click();
    window.URL.revokeObjectURL(url);
    a.remove();
  }

  private convertToBlob(imgData: any) {
    var byteString = atob(imgData.split(',')[1]);
    var mimeString = imgData.split(',')[0].split(':')[1].split(';')[0];
    var ab = new ArrayBuffer(byteString.length);
    var ia = new Uint8Array(ab);
    for (var i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
    }
    return new Blob([ab], { type: mimeString });
  }
}
